import {displayCost, displayUsage, displayPercentage} from './helper';
import {APPLIANCES_ID_TO_DETAILS, FONT_WEIGHT, USAGE_TYPE, DEFAULT_FONT_FAMILY} from '../constants/common';
import { Configuration } from '../configs/Configuration';
import { getApplianceName } from './itemizationDataHelper';

export const getCommonChartOptions = (totalCostOrConsumption, mode, isSmall, totalText, chartHeight, fuelType) =>{
    const colors = Configuration.getColors().colors;
    const options = {
        chart: {
            type: 'pie',
            marginLeft: 0,
            marginTop: 0,
            marginBotton: 0,
            height: isSmall ? 190 : chartHeight,
            spacingLeft: 0,
            style: {
              textShadow: 'none',
              color: `rgb(${colors['--color_40']})`
            }
        },
        title: {
          text : mode !== USAGE_TYPE.PERCENTAGE ? totalText : '',
          verticalAlign: 'middle',
          align: 'center',
          y: isSmall ? 0 : -10 ,
          x: isSmall ? -125 : -110,
          style:{fontSize:'16px', lineHeight: '22px'}
        },
        subtitle:{
          text: mode !== USAGE_TYPE.PERCENTAGE ? (mode === USAGE_TYPE.COST ? displayCost({cost:totalCostOrConsumption, round: true, showCurrency:true}) : displayUsage({usage:totalCostOrConsumption, round: true, showUsageUnit:true, fuelType: fuelType})) : '' ,
          verticalAlign: 'middle',
          align: 'center',
          y: 20,
          x: isSmall ? -125 : -110,
          style:{fontSize: (isSmall ? '20px' : '25px'), lineHeight:'24px',fontWeight: FONT_WEIGHT.bold}
        },
        plotOptions: {
            pie: {
                shadow: false,
                startAngle: 310,
                borderWidth: 0,
                series: {
                  allowPointSelect: false,
                  shadow: false,
                  events: {
                    legendItemClick: function() {
                      return false;
                    },
                    mouseOver : function(e){
                      e.preventDefault();
                    }
                  }
              },
              point:{
                events: {
                  legendItemClick: function() {
                    return false;
                  },
                  mouseOver : function(e){
                    e.preventDefault();
                  }
                }
              }
            }
        },
        tooltip: {
            formatter: function() {
                return '<b>'+ this.point.name +'</b>: '+ (mode === USAGE_TYPE.COST ? displayCost({cost:this.y, round: true, showCurrency:true}) : 
                (mode === USAGE_TYPE.PERCENTAGE ? displayPercentage({percentageVal : this.percentage, round : true}) : 
                displayUsage({usage:this.y, round: true, showUsageUnit:true})));
            }
        },
        legend: {
          align: 'right',
          x: 0,
          width: '200px',
          verticalAlign: 'middle',
          layout: 'vertical',
          padding: 3,
          itemMarginTop:0,
          itemMarginBottom: 20,
          itemStyle: {
              fontSize: '14px',
              color: `rgb(${colors['--color_40']})`,
              lineHeight: '22px'
          },
          labelFormatter: function() {
              return '<span style="cursor: default;">' + (mode === USAGE_TYPE.COST ? displayCost({cost:this.y, round: true, showCurrency:true}) : 
              (mode === USAGE_TYPE.PERCENTAGE ? displayPercentage({percentageVal : this.percentage, round : true}) : 
              displayUsage({usage:this.y, round: true, showUsageUnit:true}))) +' '+ this.name + '</span>';
          }
        }
    }
    return options;
}


export const getChartSeries = (outerSliceData, seriesData, innerSliceData, chartSize) => {
    var series = [];
    if(seriesData && seriesData.length === 1){
      //show only one ring in case series data length is 1
      series.push(getPieRingOptions(seriesData, chartSize.innerRing.size, chartSize.innerRing.innerSize, true));
      return series;
    }
    // outer slice
    series.push(getPieRingOptions(outerSliceData, chartSize.outerSlice.size, chartSize.outerSlice.innerSize, false));
    // inner ring
    series.push(getPieRingOptions(seriesData, chartSize.innerRing.size, chartSize.innerRing.innerSize, true));
    // inner slice
    series.push(getPieRingOptions(innerSliceData, chartSize.innerSlice.size, chartSize.innerSlice.innerSize, false));
    return series;
  }

  export const getMSBarChartOptions = (height) => {
    let options = {
      chart: {
          type: 'bar',
          animation : {enabled : false},
          marginRight : 100,
          height : height,
          spacingTop : 30
      },
      xAxis: {
          lineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: 'transparent',
          categories: [],
          title: {
              text: null
          },
          labels:{
              enabled: false
          }
      },
      yAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          min: 0,
          title: {
              text: '',
              align: ''
          },
          labels:{
            enabled: false
          }
      },
      tooltip:{
          enabled: false
      },
      plotOptions: {
          bar: {
              stacking: 'percent',
              animation : true
          },
          series: {
              borderWidth: 0,
              enableMouseTracking: false,
              pointWidth: 10,
          }
      },
      legend: {
          enabled:false
      }
    }
    return options;
  }

  export const getMSBarChartSeries = (mode , lowLightData , highlightData, appliancesList, fuelType) => {
    const colors = Configuration.getColors().colors;
    let series = [];
        //lowLighted percentage data
        series.push({
            name: '',
            data: lowLightData,
            color: `rgba(${colors['--color_1']}, 0.20)`,
            dataLabels: {
                inside: false,
                enabled: true,
                x: 90,
                useHTML: true,
                formatter: function() {
                  return '<span style="font-weight:'+FONT_WEIGHT.bold+';font-size: 16px;color: '
                  +`rgb(${colors['--color_2']})`+';">'+(mode === USAGE_TYPE.COST ? displayCost({cost: this.point.cost, round: true, showCurrency:true}) :
                  mode === USAGE_TYPE.PERCENTAGE ? displayPercentage({percentageVal : (100 - this.point.percentage), round : true}) :
                  displayUsage({usage:this.point.usage, round: true, showUsageUnit:true, fuelType: fuelType}))
                   + '</span>';
                }
            }
        });
        //highlighted percentage data
        series.push({
            name: '',
            data: highlightData,
            color: `rgb(${colors['--color_42']})`,
            dataLabels : {
              enabled : true,
              align: 'left',
              style:{
                textOutline : 0
              },
              useHTML: true,
              formatter: function(){
                return '<span style="position:absolute;top:-35px;align-items:center;"><span class="bidgely-icon-'+ APPLIANCES_ID_TO_DETAILS[this.point.id].iconClassName+
                '" style="font-size:30px;"/><div style="display:inherit;padding-left: 10px;font-weight: '+FONT_WEIGHT.semiLight+
                ';font-family: '+DEFAULT_FONT_FAMILY+';font-size: 16px;color: '
                +`rgb(${colors['--color_2']})`+';vertical-align:middle;">' + getApplianceName(this.point.id, appliancesList) + '</div></span>'
              }
            }
        })
    return series;
  }

  const getPieRingOptions = (data, ringSize, ringInnerSize, showInLegend) => {
    return {
      name: '',
      data: data,
      size: ringSize,
      innerSize: ringInnerSize,
      sizeBy: 'radius',
      showInLegend:showInLegend,
      dataLabels: {
          enabled: false
      },
      states: {
          hover: {
              enabled: false,
              halo: {
                size: 0
              }
          },
          inactive: {
            opacity: 1
          }
      }
    }
  }